export default "__VITE_ASSET__rTXFaaaQ__"